/**
 * @generated SignedSource<<e7e709cbe19e1ca8d530bb95115f277c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScriptTagSettingTabContainer_CreateModuleMutation$variables = {
  siteId: string;
  name: string;
  tagContent?: string | null;
  description?: string | null;
  priority?: number | null;
  popupGroupIds?: ReadonlyArray<string> | null;
  abtestScenarioPageGroupIds?: ReadonlyArray<string> | null;
};
export type ScriptTagSettingTabContainer_CreateModuleMutationVariables = ScriptTagSettingTabContainer_CreateModuleMutation$variables;
export type ScriptTagSettingTabContainer_CreateModuleMutation$data = {
  readonly createUserTagModule: {
    readonly site: {
      readonly " $fragmentSpreads": FragmentRefs<"ScriptTagSettingTabContainer_site">;
    };
    readonly userTagModule: {
      readonly id: string;
      readonly name: string;
      readonly enabled: boolean;
      readonly priority: number;
      readonly tagContent: string | null;
      readonly hasDraft: boolean;
    };
  } | null;
};
export type ScriptTagSettingTabContainer_CreateModuleMutationResponse = ScriptTagSettingTabContainer_CreateModuleMutation$data;
export type ScriptTagSettingTabContainer_CreateModuleMutation = {
  variables: ScriptTagSettingTabContainer_CreateModuleMutationVariables;
  response: ScriptTagSettingTabContainer_CreateModuleMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "abtestScenarioPageGroupIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "popupGroupIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priority"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagContent"
},
v7 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "abtestScenarioPageGroupIds",
        "variableName": "abtestScenarioPageGroupIds"
      },
      {
        "kind": "Variable",
        "name": "description",
        "variableName": "description"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "popupGroupIds",
        "variableName": "popupGroupIds"
      },
      {
        "kind": "Variable",
        "name": "priority",
        "variableName": "priority"
      },
      {
        "kind": "Variable",
        "name": "siteId",
        "variableName": "siteId"
      },
      {
        "kind": "Variable",
        "name": "tagContent",
        "variableName": "tagContent"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tagContent",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasDraft",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "UserTagModule",
  "kind": "LinkedField",
  "name": "userTagModule",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionNumber",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authorName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPendingChanges",
  "storageKey": null
},
v22 = [
  (v8/*: any*/),
  (v9/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v24 = [
  (v8/*: any*/),
  (v23/*: any*/)
],
v25 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Page",
  "kind": "LinkedField",
  "name": "page",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Funnel",
      "kind": "LinkedField",
      "name": "funnel",
      "plural": false,
      "selections": (v22/*: any*/),
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v27 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "moduleName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fromLabel",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "toLabel",
    "storageKey": null
  }
],
v28 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "codeDraftModuleNames",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "addedModuleNames",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "removedModuleNames",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserTagToggleChange",
    "kind": "LinkedField",
    "name": "toggleChanges",
    "plural": true,
    "selections": (v27/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserTagToggleChange",
    "kind": "LinkedField",
    "name": "linkChanges",
    "plural": true,
    "selections": (v27/*: any*/),
    "storageKey": null
  }
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionName",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ScriptTagSettingTabContainer_CreateModuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "CreateUserTagModulePayload",
        "kind": "LinkedField",
        "name": "createUserTagModule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Site",
            "kind": "LinkedField",
            "name": "site",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ScriptTagSettingTabContainer_site"
              }
            ],
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ScriptTagSettingTabContainer_CreateModuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "CreateUserTagModulePayload",
        "kind": "LinkedField",
        "name": "createUserTagModule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Site",
            "kind": "LinkedField",
            "name": "site",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "embedTag",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "robeeTag",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userTagDraft",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagModule",
                "kind": "LinkedField",
                "name": "userTagPublishedModule",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v15/*: any*/),
                  (v12/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagModule",
                "kind": "LinkedField",
                "name": "userTagModules",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v15/*: any*/),
                  (v12/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "draftContent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "draftEnabled",
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPendingToggle",
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "effectiveEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDistributionGated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDraftDistributionGated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPendingLinkChange",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isArchive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PopupGroup",
                    "kind": "LinkedField",
                    "name": "popupGroups",
                    "plural": true,
                    "selections": (v22/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbtestScenarioPageGroup",
                    "kind": "LinkedField",
                    "name": "abtestScenarioPageGroups",
                    "plural": true,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PopupGroup",
                    "kind": "LinkedField",
                    "name": "draftPopupGroups",
                    "plural": true,
                    "selections": (v22/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbtestScenarioPageGroup",
                    "kind": "LinkedField",
                    "name": "draftAbtestScenarioPageGroups",
                    "plural": true,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v25/*: any*/),
                "concreteType": "PopupGroupConnection",
                "kind": "LinkedField",
                "name": "popupGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PopupGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PopupGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v26/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "popupGroups(first:500)"
              },
              {
                "alias": null,
                "args": (v25/*: any*/),
                "concreteType": "AbtestScenarioPageGroupConnection",
                "kind": "LinkedField",
                "name": "abtestScenarioPageGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbtestScenarioPageGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AbtestScenarioPageGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v23/*: any*/),
                          (v26/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "abtestScenarioPageGroups(first:500)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagModule",
                "kind": "LinkedField",
                "name": "enabledUserTagModules",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mergedTagPreview",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "draftMergedTagPreview",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabledModuleCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalModuleCount",
                "storageKey": null
              },
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasWorkspaceDeployDrift",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagWorkspacePendingChangeSummary",
                "kind": "LinkedField",
                "name": "userTagWorkspacePendingChangeSummary",
                "plural": false,
                "selections": (v28/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagVersion",
                "kind": "LinkedField",
                "name": "userTagVersions",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v29/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v30/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserTagWorkspacePendingChangeSummary",
                    "kind": "LinkedField",
                    "name": "changeSummary",
                    "plural": false,
                    "selections": (v28/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserTagVersionModuleSnapshot",
                    "kind": "LinkedField",
                    "name": "modulesSnapshot",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "moduleId",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "gated",
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagVersion",
                "kind": "LinkedField",
                "name": "activeUserTagVersion",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v29/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v30/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d03b7e2b09dfb25387e3ce5eea997ca2",
    "id": null,
    "metadata": {},
    "name": "ScriptTagSettingTabContainer_CreateModuleMutation",
    "operationKind": "mutation",
    "text": "mutation ScriptTagSettingTabContainer_CreateModuleMutation(\n  $siteId: ID!\n  $name: String!\n  $tagContent: String\n  $description: String\n  $priority: Int\n  $popupGroupIds: [ID!]\n  $abtestScenarioPageGroupIds: [ID!]\n) {\n  createUserTagModule(input: {siteId: $siteId, name: $name, tagContent: $tagContent, description: $description, priority: $priority, popupGroupIds: $popupGroupIds, abtestScenarioPageGroupIds: $abtestScenarioPageGroupIds}) {\n    site {\n      ...ScriptTagSettingTabContainer_site\n      id\n    }\n    userTagModule {\n      id\n      name\n      enabled\n      priority\n      tagContent\n      hasDraft\n    }\n  }\n}\n\nfragment ScriptTagSettingTabContainer_site on Site {\n  id\n  embedTag\n  robeeTag\n  userTagDraft\n  userTagPublishedModule {\n    id\n    versionNumber\n    tagContent\n    status\n    description\n    authorName\n    publishedAt\n    createdAt\n  }\n  userTagModules {\n    id\n    versionNumber\n    tagContent\n    status\n    description\n    authorName\n    publishedAt\n    createdAt\n    name\n    enabled\n    priority\n    draftContent\n    draftEnabled\n    hasDraft\n    hasPendingToggle\n    hasPendingChanges\n    effectiveEnabled\n    isDistributionGated\n    isDraftDistributionGated\n    hasPendingLinkChange\n    isArchive\n    deletedAt\n    popupGroups {\n      id\n      name\n    }\n    abtestScenarioPageGroups {\n      id\n      title\n    }\n    draftPopupGroups {\n      id\n      name\n    }\n    draftAbtestScenarioPageGroups {\n      id\n      title\n    }\n  }\n  popupGroups(first: 500) {\n    edges {\n      node {\n        id\n        name\n        page {\n          funnel {\n            id\n            name\n          }\n          id\n        }\n      }\n    }\n  }\n  abtestScenarioPageGroups(first: 500) {\n    edges {\n      node {\n        id\n        title\n        page {\n          funnel {\n            id\n            name\n          }\n          id\n        }\n      }\n    }\n  }\n  enabledUserTagModules {\n    id\n    name\n    enabled\n    priority\n    tagContent\n  }\n  mergedTagPreview\n  draftMergedTagPreview\n  enabledModuleCount\n  totalModuleCount\n  hasPendingChanges\n  hasWorkspaceDeployDrift\n  userTagWorkspacePendingChangeSummary {\n    codeDraftModuleNames\n    addedModuleNames\n    removedModuleNames\n    toggleChanges {\n      moduleName\n      fromLabel\n      toLabel\n    }\n    linkChanges {\n      moduleName\n      fromLabel\n      toLabel\n    }\n  }\n  userTagVersions {\n    id\n    versionName\n    description\n    authorName\n    isActive\n    createdAt\n    content\n    changeSummary {\n      codeDraftModuleNames\n      addedModuleNames\n      removedModuleNames\n      toggleChanges {\n        moduleName\n        fromLabel\n        toLabel\n      }\n      linkChanges {\n        moduleName\n        fromLabel\n        toLabel\n      }\n    }\n    modulesSnapshot {\n      moduleId\n      name\n      enabled\n      priority\n      gated\n      tagContent\n    }\n  }\n  activeUserTagVersion {\n    id\n    versionName\n    description\n    authorName\n    isActive\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "740388e6815b4d83a1b866b9c48b4458";

export default node;
